import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-md-12 text-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left text-primary" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = { class: "card shadow-sm" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "card-title text-gray-800" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "fs-4 text-gray-700 mb-7" }
const _hoisted_10 = { class: "card bg-light bg-opacity-50 mb-5" }
const _hoisted_11 = { class: "card-body py-8" }
const _hoisted_12 = { class: "d-flex flex-column flex-center" }
const _hoisted_13 = { class: "mb-7" }
const _hoisted_14 = { class: "card-title text-gray-800 w-bolder mb-6" }
const _hoisted_15 = { class: "fs-4 text-gray-700" }
const _hoisted_16 = { class: "d-flex flex-center flex-wrap mx-auto gap-5 w-xl-900px" }
const _hoisted_17 = { class: "octagon d-flex flex-center h-200px w-200px bg-body mx-lg-10" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<i class=\"ki-duotone ki-element-11 fs-2tx text-primary\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span></i>", 1)
const _hoisted_20 = { class: "mt-1 text-center" }
const _hoisted_21 = { class: "fs-lg-2hx fs-2x fw-bold text-gray-800 d-flex justify-content-center align-items-center text-center" }
const _hoisted_22 = {
  class: "min-w-70px counted",
  "data-kt-countup": "true",
  "data-kt-countup-value": "700",
  "data-kt-initialized": "1"
}
const _hoisted_23 = { class: "text-gray-600 fw-semibold fs-5 lh-0" }
const _hoisted_24 = { class: "octagon d-flex flex-center h-200px w-200px bg-body mx-lg-10" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-chart-pie-4 fs-2tx text-success" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" })
], -1)
const _hoisted_27 = { class: "mt-1" }
const _hoisted_28 = { class: "fs-lg-2hx fs-2x fw-bold text-gray-800 d-flex align-items-center justify-content-center" }
const _hoisted_29 = {
  class: "min-w-50px counted",
  "data-kt-countup": "true",
  "data-kt-countup-value": "80",
  "data-kt-initialized": "1"
}
const _hoisted_30 = { class: "text-gray-600 fw-semibold fs-5 lh-0" }
const _hoisted_31 = { class: "card bg-light bg-opacity-50 my-5" }
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = { class: "mb-7" }
const _hoisted_34 = { class: "card-title text-gray-800 w-bolder mb-6" }
const _hoisted_35 = { class: "fw-semibold fs-4 text-gray-600" }
const _hoisted_36 = { class: "card bg-light bg-opacity-50 mt-5" }
const _hoisted_37 = { class: "card-body" }
const _hoisted_38 = { class: "mb-7" }
const _hoisted_39 = { class: "card-title text-gray-800 w-bolder mb-6" }
const _hoisted_40 = { class: "fw-semibold fs-4 text-gray-600" }
const _hoisted_41 = { class: "d-flex align-items-center mb-3 ms-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot me-3 h-8px w-8px" }, null, -1)
const _hoisted_43 = { class: "text-gray-700 w-bolder mb-0" }
const _hoisted_44 = {
  key: 0,
  class: "my-2 ms-10"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "bullet me-3" }, null, -1)
const _hoisted_46 = { class: "text-gray-600 fw-semibold fs-6" }
const _hoisted_47 = { class: "fw-semibold fs-4 text-gray-600" }
const _hoisted_48 = { class: "card-footer" }
const _hoisted_49 = { class: "d-flex flex-column" }
const _hoisted_50 = { class: "d-flex mb-1 justify-content-center border-b" }
const _hoisted_51 = {
  key: 0,
  class: "text-success fs-7 text-center"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = {
  key: 1,
  class: "text-danger fs-7 text-center"
}
const _hoisted_54 = {
  key: 2,
  class: "text-danger fs-7 text-center"
}
const _hoisted_55 = {
  key: 0,
  class: "justify-content-center d-flex align-items-center"
}
const _hoisted_56 = { class: "d-flex align-items-center me-5" }
const _hoisted_57 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_58 = ["checked"]
const _hoisted_59 = { class: "form-check-label text-gray-800" }
const _hoisted_60 = { class: "" }
const _hoisted_61 = {
  key: 1,
  style: {"padding":"8px 16px"},
  class: "bg-secondary ki-text-bold fs-7 d-flex text-gray-600 justify-content-center align-items-center rounded"
}
const _hoisted_62 = {
  key: 1,
  class: "justify-content-center d-flex align-items-center"
}
const _hoisted_63 = { class: "d-flex align-items-center me-5" }
const _hoisted_64 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input w-15px h-15px",
  type: "checkbox",
  disabled: ""
}, null, -1)
const _hoisted_66 = { class: "form-check-label text-gray-600" }
const _hoisted_67 = { class: "" }
const _hoisted_68 = {
  key: 0,
  class: "btn btn-sm btn-light-success"
}
const _hoisted_69 = {
  key: 1,
  style: {"padding":"8px 16px"},
  class: "bg-secondary ki-text-bold fs-7 d-flex text-gray-600 justify-content-center align-items-center rounded"
}
const _hoisted_70 = {
  key: 1,
  class: "d-flex flex-column py-6"
}
const _hoisted_71 = { class: "container text-center mt-5" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_73 = { class: "text-muted fs-3 fw-bold mt-3 mb-6" }

import { computed, ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import ApiService from "@/core/services/ApiService";
import { useI18n } from 'vue-i18n';
import moment from "moment";
import {useCertificationSteps} from "@/core/composables/useCertificationSteps";

interface CertificationCriteriaItem {
  description: string;
  items: string[] | null;
}

interface CertificationData {
  id: number;
  name: string;
  lesson_percentual: number;
  challenge_percentual: number;
  deadline_description: string;
  criteria: CertificationCriteriaItem[];
}

interface CertificationStep {
  order: number;
  type: string;
  component: string;
  deadline_days?: number;
  required: boolean;
  title: string;
  description: string;
  has_download?: boolean;
  has_upload?: boolean;
  download_file_key?: string;
}

interface CertificationSettings {
  minimum_grade: number;
  allow_retries: boolean;
  retry_cooldown_days: number;
  minimum_machines_required: number;
  timeout_months: number;
  // Campos legados mantidos apenas para compatibilidade de leitura
  // O backend agora usa deadline_days de cada step individual
  modeling_deadline_days?: number;
  execution_deadline_days?: number;
  report_deadline_days?: number;
}

interface CertificationConfig {
  id: number;
  name: string;
  strategy_type: string;
  has_machines: boolean;
  has_report: boolean;
  has_custom_steps: boolean;
  steps: CertificationStep[];
  settings: CertificationSettings;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const router = useRouter();
const route = useRoute();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const certificationOK = ref<boolean>();
const anotherCertificationInProgress = ref<boolean>();
const terms = ref(false);
const isChecked = ref(false);
const loading = ref(false);
const certificationData = ref<CertificationData | null>(null);
const certificationConfig = ref<CertificationConfig | null>(null);
const certificationId = computed(() => route.params.id as string);

const { 
  loadCertificationData, 
  statusData, 
  currentStep,
  steps
} = useCertificationSteps(certificationId.value, 'certification_show');

const fetchCertificationData = async () => {
  try {
    const { data, status } = await ApiService.get(`/certification/${certificationId.value}`);
    if (status === 200) {
      certificationData.value = data.data;
    }
  } catch (e: any) {
    console.log('Error fetching certification data:', e);
  }
};

const fetchCertificationConfig = async () => {
  try {
    const { data, status } = await ApiService.get(`/certification/${certificationId.value}/config`);
    if (status === 200) {
      certificationConfig.value = data.data;
    }
  } catch (e: any) {
    console.log('Error fetching certification config:', e);
  }
};

const canRetryFromStatus = (payload: any): boolean => {
  const statusData = payload?.data ?? payload;
  const canRetryFlag = statusData?.can_retry ?? statusData?.canRetry;
  if (typeof canRetryFlag === "boolean") return canRetryFlag;

  const approved = statusData?.approved === true || statusData?.approved === 1;
  if (approved) return false;

  const timeout = statusData?.timeout;
  if (!timeout) return false;

  const parsed = moment(timeout, "YYYY-MM-DD HH:mm:ss", true);
  const timeoutMoment = parsed.isValid() ? parsed : moment(timeout);
  return timeoutMoment.isValid() ? timeoutMoment.isBefore(moment()) : false;
};

const statusCertification = async () => {
  try {
    // Carrega dados usando o composable
    await loadCertificationData();
    
    if (statusData.value) {
      console.log('Status atual da certificação:', currentStep.value);
      
      // Encontra o step de feedback dinamicamente
      const feedbackStep = steps.value.find(step => step.component === 'certification_feedback');
      
      // Verifica se está no step de feedback e pode fazer retry
      if (feedbackStep && currentStep.value === feedbackStep.order && canRetryFromStatus(statusData.value)) {
        await checkedRequirementsCertification();
      }
    }
  } catch (e: any) {
    if (e?.response?.data?.message === "certificado ainda não iniciado") {
      console.log('e.response.data.message', e.response.data.message);
      await checkedRequirementsCertification();
    }
  }
}

const checkedRequirementsCertification = async () => {
  try {
    const { data, status } = await ApiService.get(`/certification/check/${certificationId.value}`)
    if (status === 200) {
      if (data["message"] === "Usuário pode iniciar certificação") {
        certificationOK.value = true
      }
    }
  } catch (e: any) {
    console.log(e)
    // Redirecionamentos removidos - lógica será reimplementada no futuro
    if (e?.response?.data?.message === "usuário não assinante." ||
        e?.response?.data?.message === "usuário não possui os pré requisitos.") {
      certificationOK.value = false
    } else if (e?.response?.data?.message === "usuário só pode fazer uma certificação por vez" ||
               e?.response?.data?.message === "usuário já fez a certificação e já passou" ||
               e?.response?.data?.message === "Somente depois de transcorridos seis meses a partir da data de reprovação, o usuário poderá fazer a certificação.") {
      // Usuário tem status especial - não pode iniciar certificação no momento
      certificationOK.value = false
    }else if(e?.response?.data?.status === 'ongoing_certification'){
      certificationOK.value = false
      anotherCertificationInProgress.value = true
    }
  }
}

onMounted(async () => {
  loading.value = true
  try {
    await fetchCertificationData();
    await fetchCertificationConfig();
    await statusCertification();
  } catch (e: any) {
    console.log(e)
  } finally {
    loading.value = false
  }
})
const checkedTerms = () => {
  isChecked.value = !isChecked.value;
  terms.value = isChecked.value;
}
const startCertification = async () => {
  try {
    await ApiService.get(`/certification/ask/${certificationId.value}`)
    // Força reload da página para o guard redirecionar para a rota correta
    router.go(0);
  } catch (e: any) {
    console.log(e)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'certifications' },
          class: "text-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.back`)), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.title`)), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.description`)), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.who_can_request`)), 1),
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.who_can_request_desc`, { 
                        lessonPercentual: certificationData.value?.lesson_percentual || 0, 
                        challengePercentual: certificationData.value?.challenge_percentual || 0 
                      })), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, _toDisplayString(certificationData.value?.lesson_percentual || 0) + "%", 1)
                            ]),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.classes_attended`)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, _toDisplayString(certificationData.value?.challenge_percentual || 0) + "%", 1)
                            ]),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.complete_challenges`)), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("h2", _hoisted_34, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.dates_and_deadlines`)), 1),
                    _createElementVNode("p", _hoisted_35, _toDisplayString(certificationData.value?.deadline_description || _ctx.$t(`${_unref(currentLanguage)}.certification.index.dates_and_deadlines_desc`)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("h2", _hoisted_39, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.certification_criteria`)), 1),
                    _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.to_obtain_certificate`)), 1)
                  ]),
                  (certificationData.value?.criteria)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(certificationData.value.criteria, (criterion, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "mb-8"
                        }, [
                          _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("h4", _hoisted_43, _toDisplayString(criterion.description), 1)
                          ]),
                          (criterion.items && criterion.items.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criterion.items, (item, itemIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: itemIndex,
                                    class: "d-flex align-items-center mb-3"
                                  }, [
                                    _hoisted_45,
                                    _createElementVNode("div", _hoisted_46, _toDisplayString(item), 1)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.after_delivery_of_reports`)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  (certificationOK.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_51, [
                        _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.messages.congratulations`)) + "!! ", 1),
                        _hoisted_52,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.you_meet_the_requirements`)), 1)
                      ]))
                    : (anotherCertificationInProgress.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.another_certification_in_progress`)), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.you_dont_meet_the_requirements`)), 1))
                ]),
                (certificationOK.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("label", _hoisted_57, [
                          _createElementVNode("input", {
                            onClick: checkedTerms,
                            class: "form-check-input w-15px h-15px",
                            type: "checkbox",
                            checked: isChecked.value
                          }, null, 8, _hoisted_58),
                          _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.i_am_aware_of_deadlines_and_requirements`)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        (terms.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: startCertification,
                              class: "btn btn-sm btn-light-success"
                            }, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.i_want_to_get_certified`)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.i_want_to_get_certified`)), 1))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("label", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.i_am_aware_of_deadlines_and_requirements`)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        (terms.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.i_want_to_get_certified`)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.i_want_to_get_certified`)), 1))
                      ])
                    ]))
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _hoisted_72,
            _createElementVNode("span", _hoisted_73, "   " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.analyzing_the_requirements`)) + "...", 1)
          ])
        ]))
  ]))
}
}

})